import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthResponse, LoginPayload, ProleisUser } from '../../models/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  httpClient = inject(HttpClient);

  login(payload: LoginPayload): Observable<AuthResponse> {
    return this.httpClient.post<AuthResponse>(
      `${environment.API_LOCATION}/auth/login`,
      payload
    );
  }

  getCurrentUser(): Observable<ProleisUser> {
    return this.httpClient.get<ProleisUser>(`${environment.API_LOCATION}/user`);
  }
}
